'use strict'

PageTracking = require '../../../modules/page/frontend/helpers/tracking'

module.exports =
  initialize: (@config) ->
    @tracking = new PageTracking()
    @_addListeners()

  onReady: ->
    $('body').removeClass('no-js')
    $('body').addClass('pull-app-is-ready')

  onLoad: ->
    @tracking.pageReady()
    $('body').addClass('pull-app-is-loaded')

  _addListeners: ->
    $(document).ready => @onReady()
    $(window).one 'load', => @onLoad()
